import Layout from "./Layout";
import WizardNode from "./WizardNode";
import WizardStepNode from "./WizardStepNode";
import WizardNextNode from "./WizardNextNode";
import WizardBackNode from "./WizardBackNode";
import WizardTabsNode from "./WizardTabsNode";

export const nodeRegistry: any = {
    layout: Layout,
    
    wizard: WizardNode,
    wizard_step: WizardStepNode,
    wizard_next: WizardNextNode,
    wizard_back: WizardBackNode,
    wizard_tabs: WizardTabsNode,
};

export default nodeRegistry;